import { createFileRoute } from '@tanstack/react-router'
import { AppShell } from '../../components/AppShell'
import { PanduanPlatform } from '../../components/PanduanPenggunaan'
import { useLogout, useSession } from '../../hooks/useApi'

export const Route = createFileRoute('/platform/panduan')({
  component: PanduanPage,
})

function PanduanPage() {
  const { data: session } = useSession()
  const logout = useLogout()
  const user = session?.user

  return (
    <AppShell
      mode="global"
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
    >
      <PanduanPlatform />
    </AppShell>
  )
}
